module.exports = `${require.publicPath}ckeditor5.dfd1888b.scss`;